export default __webpack_public_path__ + "static/media/grafema_clivitalbio_01.143c7674.jpg";